import { render, staticRenderFns } from "./PlayerPhotos.vue?vue&type=template&id=41dcb994"
import script from "./PlayerPhotos.vue?vue&type=script&lang=js"
export * from "./PlayerPhotos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports